import { PaginatedResponse } from "@/types/api";
import { AuthData } from "@/types/employee";
import { apiUrl } from "../../utils/url";
import { Employee } from "../agenda/types";
import { HttpClient } from "../HttpClient";
import {
  GetEmployeesWithAvailableSlotsParams,
  IEmployeesService,
} from "./IEmployeesService";

export class EmployeesService implements IEmployeesService {
  private httpClient: HttpClient;

  constructor() {
    this.httpClient = new HttpClient({
      baseURL: apiUrl,
      timeout: 60000, // 1 min
      headers: {},
    });
  }

  async getEmployees(): Promise<PaginatedResponse<Employee>> {
    try {
      return await this.httpClient.get<PaginatedResponse<Employee>>(
        "/employees/all",
      );
    } catch (error) {
      throw new Error(
        error instanceof Error
          ? error.message
          : "Não foi possível carregar os funcionários. Atualize a página e tente novamente.",
      );
    }
  }

  async getEmployeeById(id: string): Promise<Employee> {
    try {
      return await this.httpClient.get<Employee>(`/employees/${id}`);
    } catch (error) {
      throw new Error(
        error instanceof Error
          ? error.message
          : "Não foi possível carregar os funcionários. Atualize a página e tente novamente.",
      );
    }
  }

  async getEmployeeByExternalId(externalId: string): Promise<AuthData> {
    try {
      return await this.httpClient.get<AuthData>(
        `/employees/external-code/${externalId}`,
      );
    } catch (error) {
      throw new Error(
        error instanceof Error
          ? error.message
          : "Não foi possível carregar os funcionários. Atualize a página e tente novamente.",
      );
    }
  }

  async getCurrentEmployee(): Promise<Employee> {
    try {
      return await this.httpClient.get<Employee>(
        "/employees/employee-from-token",
      );
    } catch (error) {
      throw new Error(
        error instanceof Error
          ? error.message
          : "Não foi possível carregar os funcionários. Atualize a página e tente novamente.",
      );
    }
  }

  async getEmployeesByStoreUUID(storeUUID: string): Promise<Employee[]> {
    try {
      return await this.httpClient.get<Employee[]>(
        `/employees/store/${storeUUID}`,
      );
    } catch (error) {
      throw new Error(
        error instanceof Error
          ? error.message
          : "Não foi possível carregar os funcionários. Atualize a página e tente novamente.",
      );
    }
  }

  async getEmployeesWithAvailableSlots(
    params: GetEmployeesWithAvailableSlotsParams,
  ): Promise<Employee[]> {
    try {
      return await this.httpClient.post<Employee[]>(
        "/employees/with-available-slots",
        params,
      );
    } catch (error) {
      throw new Error(
        error instanceof Error
          ? error.message
          : "Não foi possível carregar funcionários com disponibilidade. Altere os filtros ou tente novamente.",
      );
    }
  }
}
